import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { AdvtService } from '../../_services/advt.service';
import { AlertService } from '../../_services/alert.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Http } from '@angular/http';
import { Subscription } from 'rxjs/Subscription';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
@Component({
  selector: 'app-bid-item-update',
  templateUrl: './bid-item-update.component.html',
  styleUrls: ['./bid-item-update.component.css']
})
export class BidItemUpdateComponent implements OnInit {
  @ViewChild("myVideo") public myVideo: any;
  @ViewChild("myAudio") public myAudio: any;
  @ViewChild("template") public template: TemplateRef<any>;

  modalRef: BsModalRef;
  private sub: Subscription;
  public _id;
  item_id;
  amount: any = '';
  buyer_id;
  public listSingleItem;
  public bidPost: Boolean = false;
  galleryOptions: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[];
  galleryMusic = [];
  placeholder: any;
  currentUser: any;
  NAP;
  myTracks: any[];
  allTracks: any[];
  selectedTrack;
  ItemData;
  bidButton: Boolean = false;
  bidAmount;
  timeset;
  duration;
  control;
  MaxAmount;
  maxAmt;
  userId: string;
  constructor(private advtService: AdvtService,
    private alertService: AlertService,
    private modalService: BsModalService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.NAP = '../../assets/images/nap.jpg';

    const userInfo = JSON.parse(localStorage.getItem('currentUser'));
    this.currentUser = userInfo ? userInfo.result : null;
    this.userId = userInfo.result.id;
    this.buyer_id = userInfo.result ? userInfo.result.id : null;

    this.sub = this.route.params.subscribe((params) => {
      this._id = params['id'];
    });
    this.placeholder = '../../assets/images/pdf.png';


    this.getItemDetail();

    this.galleryOptions = [
      {
        width: '100%',
        height: '400px',
        thumbnailsColumns: 4,
        imageAnimation: NgxGalleryAnimation.Slide,
      },
      // max-width 800
      {
        breakpoint: 800,
        width: '100%',
        height: '600px',
        imagePercent: 80,
        thumbnailsPercent: 20,
        thumbnailsMargin: 20,
        thumbnailMargin: 20,
      },
      // max-width 400
      {
        breakpoint: 400,
        preview: false,
      }
    ];
  }

  /**
   * 
   */
  public getItemDetail() {
    this.item_id = this._id;
    this.galleryImages = [];
    this.galleryMusic = [];

    this.advtService.getItemDetail(this.item_id)
      .subscribe(data => {
        this.ItemData = data;
        // this.timeset = (data.meta.videos + '#t=0,10');
        if (data.category_id == 2) {
          if (typeof data.meta.preview_images !== 'undefined') {
            if (data.imgName) {
              this.galleryImages = [];
              for (let i = 0; i < Object.keys(data.meta.preview_images).length; i++) {
                if (typeof data.meta.preview_images[i] !== 'undefined') {
                  const csvArray = data.meta.preview_images[i];
                  this.galleryImages.push({
                    small: csvArray,
                    medium: csvArray,
                    big: csvArray
                  });
                }
              }
            }
          }
        } else {
          if (data.imgName) {
            this.galleryImages = [];
            for (let i = 0; i < Object.keys(data.meta.images).length; i++) {
              if (typeof data.meta.images[i] !== 'undefined') {
                const csvArray = data.meta.images[i];
                this.galleryImages.push({
                  small: csvArray,
                  medium: csvArray,
                  big: csvArray
                });
              }
            }
          }
        }

        if (data.meta && data.meta.music) {
          this.galleryMusic = [];
          for (let i = 0; i < Object.keys(data.meta.music).length; i++) {
            if (typeof data.meta.music[i] !== 'undefined') {
              const csvArray = data.meta.music[i];
              this.galleryMusic.push({ 'music_url': csvArray, 'music_name': data.meta.music_name[i] });
            }
          }
        }
        this.listSingleItem = data;
        //this.duration = "#t=0,10";
      }, error => {
        this.alertService.error(error);
      });
  }

  /**
   * Function to post Bid
   */
  public UpdateBid() {
    let params = {
      buyer_id: this.listSingleItem.amount.buyer_id,
      item_id: this._id,
      bid_id: this.listSingleItem.amount.id,
      amount: this.listSingleItem.amount.amount
    }
    this.advtService.updateBid(params).subscribe(data => {
      if (data.status === 200) {
        this.bidAmount = data;
        this.ItemData.status_id = 5;
        this.bidPost = true;
        this.alertService.success("Bid Updated Successfully!");
        setTimeout(() => {
          this.router.navigate(['/notification']);
        }, 2000);
      } else {
        this.bidPost = false;
      }
    }, error => {
      this.alertService.error(error);
    });
  }

  /**
   * function to enable or disable Bid button  on basis of bid type  
   * @param searchValue : Data coming in input field 
   */
  public minBid(searchValue: any) {
    this.MaxAmount = 970873.77;
    if (this.ItemData.bid_type_name === 'Minimum') {
      if (parseInt(this.ItemData.min_bid) <= searchValue) {
        this.bidButton = true;
      } else {
        this.bidButton = false;
      }
    }
    if (this.ItemData.bid_type_id === 1) {
      this.bidButton = true;
    }
    if (!searchValue) {
      this.bidButton = false;

    }
    if (Number(this.MaxAmount) <= searchValue) {
      this.maxAmt = true;
    } else {
      this.maxAmt = false;

    }
  }

  _checkNumPattern(event: any) {
    const pattern = /[0-9\+\.\ ]/;
    if (event.which === 32 && event.target.selectionStart === 0) {
      return false;
    }
    if (event.which === 48 && event.target.selectionStart === 0) {
      return false;
    }
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }




  /**
 * Function to open modal
 * @param template 
 */
  public openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-md' })
    );
  }

  /**
  * function to Disbale Modal
  * @param event 
  */
  _hidemodal(event: any) {
    this.modalRef.hide();
  }


}



// WEBPACK FOOTER //
// ./src/app/authorized-data/bid-item-update/bid-item-update.component.ts